import { render, staticRenderFns } from "./wl1AutoChannel.vue?vue&type=template&id=f2ba7584&scoped=true&"
import script from "./wl1AutoChannel.vue?vue&type=script&lang=js&"
export * from "./wl1AutoChannel.vue?vue&type=script&lang=js&"
import style0 from "./wl1AutoChannel.vue?vue&type=style&index=0&id=f2ba7584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ba7584",
  null
  
)

export default component.exports